import { NavLink, useLocation } from "react-router-dom";
import "./side-bar.scss";

type NavItem = {
  to: string;
  label: string;
  sub: string;
  icon: string;
  /** When set, item is active only if pathname matches this regex (else NavLink default) */
  match?: RegExp;
  end?: boolean;
};

type NavSection = { title: string; items: NavItem[] };

const SECTIONS: NavSection[] = [
  {
    title: "Dashboard",
    items: [
      {
        to: "/mes-dashboard",
        label: "Overview",
        sub: "At a glance",
        icon: "fa-th-large",
        end: true,
      },
    ],
  },
  {
    title: "Orders & parts",
    items: [
      {
        to: "/mes-order",
        label: "Production Orders",
        sub: "Incoming demand",
        icon: "fa-shopping-cart",
        match: /^\/mes-order(\/order\/[^/]+)?\/?$/,
      },
      {
        to: "/mes-parts",
        label: "Parts Catalog",
        sub: "Parts from orders",
        icon: "fa-cube",
        end: true,
      },
    ],
  },
  {
    title: "Process planning",
    items: [
      {
        to: "/mes-order/cad-manufacturing",
        label: "CAD → Manufacturing",
        sub: "Design-to-process intake",
        icon: "fa-square-o",
        end: false,
      },
      {
        to: "/mes-operations",
        label: "Process Definitions",
        sub: "Operations & machines",
        icon: "fa-cog",
        end: true,
      },
      {
        to: "/mes-workflow",
        label: "Workflow Templates",
        sub: "Composed sequences",
        icon: "fa-sitemap",
        end: true,
      },
      {
        to: "/mes-trurecipe/library",
        label: "TruRecipe Library",
        sub: "Parameter blueprints",
        icon: "fa-flask",
        /** Library + recipe detail share this nav highlight (not compare/guided/twin). */
        match: /^\/mes-trurecipe\/(library|recipe\/[^/]+)\/?$/,
      },
      {
        to: "/mes-trurecipe/compare",
        label: "Compare Recipes",
        sub: "Side-by-side diff",
        icon: "fa-sitemap",
        end: true,
      },
    ],
  },
  {
    title: "Production",
    items: [
      {
        to: "/mes-jobs",
        label: "Jobs",
        sub: "Order execution",
        icon: "fa-wrench",
        end: true,
      },
      {
        to: "/mes-trurecipe/guided",
        label: "Guided Instructions",
        sub: "AR operator view",
        icon: "fa-book",
        end: true,
      },
      {
        to: "/mes-trurecipe/digital-twin",
        label: "Digital Twin",
        sub: "Should vs Is monitoring",
        icon: "fa-line-chart",
        end: true,
      },
    ],
  },
  {
    title: "Resources",
    items: [
      {
        to: "/mes-workcenter",
        label: "Machines",
        sub: "Factory equipment",
        icon: "fa-server",
        end: true,
      },
      {
        to: "/mes-operators",
        label: "Operators",
        sub: "Personnel & skills",
        icon: "fa-user",
        end: true,
      },
      // {
      //   to: "/mes-tasks",
      //   label: "Tasks",
      //   sub: "Work assignments",
      //   icon: "fa-check-square-o",
      //   end: true,
      // },
    ],
  },
];

function itemActive(pathname: string, item: NavItem): boolean {
  if (item.match) return item.match.test(pathname);
  return pathname === item.to || pathname.startsWith(`${item.to}/`);
}

const SideBar = () => {
  const { pathname } = useLocation();

  return (
    <aside className="clsLeftBlock clsLeftNav tv-sidebar--v2 tv-sidebar--v2-ref">
      <div className="tv-sidebar-inner tv-sidebar-inner--v2-ref">
        {SECTIONS.map((section) => (
          <div key={section.title} className="tv-v2-section">
            <div className="tv-v2-section__title">{section.title}</div>
            <nav className="tv-v2-nav" aria-label={section.title}>
              {section.items.map((item) => {
                const active = itemActive(pathname, item);
                return (
                  <NavLink
                    key={item.to + item.label}
                    to={item.to}
                    end={item.match ? false : Boolean(item.end)}
                    className={() =>
                      `tv-v2-nav-item${active ? " tv-v2-nav-item--active" : ""}`
                    }
                  >
                    <span className="tv-v2-nav-item__icon" aria-hidden>
                      {item.label === "CAD → Manufacturing" ? (
                        <span className="tv-v2-cad-icon">
                          <span className="tv-v2-cad-icon__inner" />
                        </span>
                      ) : (
                        <i className={`fa ${item.icon}`} />
                      )}
                    </span>
                    <span className="tv-v2-nav-item__text">
                      <span className="tv-v2-nav-item__label">{item.label}</span>
                      <span className="tv-v2-nav-item__sub">{item.sub}</span>
                    </span>
                  </NavLink>
                );
              })}
            </nav>
          </div>
        ))}
{/* 
        <div className="tv-v2-section">
          <div className="tv-v2-section__title">Quality & reports</div>
          <div className="tv-v2-nav-item tv-v2-nav-item--disabled" aria-disabled>
            <span className="tv-v2-nav-item__icon" aria-hidden>
              <i className="fa fa-check-square-o" />
            </span>
            <span className="tv-v2-nav-item__text">
              <span className="tv-v2-nav-item__label">Quality Control</span>
              <span className="tv-v2-nav-item__sub">Inspection & testing</span>
            </span>
          </div>
          <div className="tv-v2-nav-item tv-v2-nav-item--disabled" aria-disabled>
            <span className="tv-v2-nav-item__icon" aria-hidden>
              <i className="fa fa-line-chart" />
            </span>
            <span className="tv-v2-nav-item__text">
              <span className="tv-v2-nav-item__label">Reports</span>
              <span className="tv-v2-nav-item__sub">Analytics & insights</span>
            </span>
          </div>
        </div> */}
      </div>
    </aside>
  );
};

export default SideBar;
